import { useLocation } from 'react-router-dom';
// utils
import userAgent from '../../utils/user-agent';
// styles
import { AuthWrapper, PasswordIcon, EmailIcon, NotifyTitle, PrimaryButton } from '../../styles';
// apis
import { logout } from '../../apis';

// ----------------------------------------------------------------------

export default function SuccessPage() {
  const state = useLocation().state;

  const handleLogout = async () => {
    const UA = userAgent();
    await logout(UA, '/login');
  };

  return (
    <AuthWrapper>
      { state.type === 'password' ?
        <PasswordIcon />
        : <EmailIcon />
      }
      <NotifyTitle>
        <p>
          { state.type === 'password' ?
            '비밀번호 변경이\n완료되었습니다.'
            : '임시 비밀번호 메일이\n발송되었습니다.'
          }
        </p>
        <span>
          { state.type === 'password' ?
            '로그인 후 서비스를 이용하실 수 있습니다.\n새로운 비밀번호로 로그인해 주세요.'
            : '임시 비밀번호로 로그인 후 비밀번호를 변경해 주세요.\n변경된 비밀번호로 로그인하시면\n정상적으로 서비스를 이용하실 수 있습니다.'
          }
        </span>
      </NotifyTitle>

      <PrimaryButton onClick={() => handleLogout()} style={{'width': '100%'}}>로그인</PrimaryButton>
    </AuthWrapper>
  );
}